/**
 * 参考: 総務省 電気通信番号指定状況 携帯電話・PHSの電話番号
 * @see https://www.soumu.go.jp/main_sosiki/joho_tsusin/top/tel_number/number_shitei.html
 */
const mobilePhoneRegexp = new RegExp(/^0[6789]0[-]?\d{4}[-]?\d{4}$/);

const mobilePhone = (value: string) => {
  if (value === "") {
    return true;
  }

  return mobilePhoneRegexp.test(value);
};

export default mobilePhone;
